<template>
  <div class="flex flex-col bg-white rounded-t-[12px] h-full">
    <div class="flex flex-row mx-auto md:text-normal text-xs text-center justify-center items-center mt-5 w-3/4">
    <StepIndicator
      v-for="(label, index) in steps"
      :key="index"
      :step="index + 1"
      :currentStep="$store.state.step"
      :label="label"
    />
  </div>
      <div class="flex flex-col justify-center ">
        <!-- <step-one v-if="$store.state.step === 1"></step-one> -->
        <CampaignInfo v-if="$store.state.step === 1"/>
        <!-- <step-two v-if="$store.state.step === 2"></step-two> -->
        <location-step v-if="$store.state.step === 2"></location-step>
        <!-- <step-three v-if="$store.state.step === 3"></step-three> -->
        <!-- <step-four v-if="$store.state.step === 3"></step-four> -->
        <media-step v-if="$store.state.step === 3"></media-step>
        <!-- <ReviewAndPay /> -->
      </div>

  </div>
</template>

<script>
import StepFour from "../../components/CampaignTaps/StepFour.vue";
import StepOne from "../../components/CampaignTaps/StepOne.vue";
import StepThree from "../../components/CampaignTaps/StepThree.vue";
import StepTwo from "../../components/CampaignTaps/StepTwo.vue";
import LocationStep from "../../components/CampaignTaps/LocationStep.vue";
import 'animate.css';
import CampaignInfo from "../../components/CampaignTaps/CampaignInfo.vue";
import MediaStep from "../../components/CampaignTaps/MediaStep.vue";
import StepIndicator from "../../components/CampaignTaps/StepIndicator.vue";
import ReviewAndPay from "../../components/CampaignTaps/ReviewAndPay.vue"

export default {
  components: { StepTwo, StepOne, StepThree, StepFour, LocationStep ,CampaignInfo, MediaStep, StepIndicator, ReviewAndPay},

  data() {
    return {
      steps: ["Campaign Info", "Targeting", "Confirm"],
    };
  },
  beforeUnmount() {
    this.$store.commit("restoreStat");
  },
  mounted() {
  },
}
</script>

<style>
</style>
